export  enum  ScreenScales  {

    SevenHundreds = 0.68,
    SixHundreds = 0.52,
    FiveHundreds = 0.5,
    FourHundreds =  0.40,
    ThreeHundreds =  0.36,
    TwoHundreds =  0.35,
}

export  enum  MaxScreenSize{
    MaxtWidth = 700,
    MaxHeight = 700,
}